<template>
  <v-layout row>
    <v-flex
      grow-shrink-0
      v-for="(button, key) in keys"
      :key="key">
      <v-btn
        v-if="button !== null"
        @click="handle({ val: button, key: key})"
        outlined
        color="orange">{{ key }}
      </v-btn>
      <v-tooltip v-else bottom>
        <template v-slot:activator="{ on }">
          <div v-on="on">
            <v-btn
              @click="handle({ val: button, key: key})"
              disabled
              outlined
              color="orange">{{ key }}
            </v-btn>
          </div>
        </template>
        <span>Tanımlı değil</span>
      </v-tooltip>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'ButtonKeys',
  props: {
    keys: {},
    itemValue: {
      default: () => 'key',
    },
  },
  methods: {
    handle(dat) {
      const emitVal = this.itemValue === 'key' ? dat.key : dat.val;
      this.$emit('on:button-key', emitVal);
    },
  },
};
</script>

